const imp = () => import(/* webpackChunkName: "loadSprite_supplement"*/  "../sprite/loadSprite_supplement");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-AND": imp,
  "Icon-Actuator-management": imp,
  "Icon-Actuator-management-o": imp,
  "Icon-Change-Password-o": imp,
  "Icon-Day-view": imp,
  "Icon-Change-Password": imp,
  "Icon-List-view": imp,
  "Icon-Maximize": imp,
  "Icon-Month-view": imp,
  "Icon-Mutual-concern": imp,
  "Icon-OR": imp,
  "Icon-One-way-attention": imp,
  "Icon-Scan-code": imp,
  "Icon-Send-a-message-o": imp,
  "Icon-Send-a-message": imp,
  "Icon-Special-attention": imp,
  "Icon-Three-day-view": imp,
  "Icon-Weekly-view": imp,
  "Icon-add-group": imp,
  "Icon-add-group-o": imp,
  "Icon-dispatch-o": imp,
  "Icon-dispatch": imp,
  "Icon-edit-o": imp,
  "Icon-edit": imp,
  "Icon-group02-o": imp,
  "Icon-ma'am": imp,
  "Icon-man": imp,
  "Icon-split": imp,
  "Icon-enlarge02": imp,
  "Icon-group02": imp,
  "Icon-narrow02": imp,
  "Icon-ma'am02": imp,
  "Icon-man02": imp,
}
export default loadMap;